import { combineReducers } from 'redux'
import events from './events'
import misc from './misc'

export default combineReducers({
  events,
  misc,
})
